import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-module',
  templateUrl: './module.component.html',
  styleUrls: ['./module.component.scss']
})
export class ModuleComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}



// WEBPACK FOOTER //
// /var/www/ras.universarium.org/www/src/app/module/module.component.ts